import React from 'react';
import clsx from 'clsx';
import { Icon, Table } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';

const cellIcons = (items, context, entity, intl) => (
  items.map((item) => (
    <Icon
      key={`message_row_icon_${entity}_${context}_${item}`}
      className="primary"
      name={item}
      title={intl.formatMessage({ id: `${entity}.row.${context}.${item.split(' ').join('.')}.title` })}
    />
  ))
);

const MessageRow = ({
  children,
  className,
  context,
  collapsing,
  entity,
  icons = [],
  labelWidth,
  message,
  title,
}) => {
  const intl = useIntl();
  return (
    <Table.Row className="aridhia-message-row">
      <Table.Cell collapsing={collapsing} width={labelWidth}>
        <span title={intl.formatMessage({ id: message })}>
          {cellIcons(icons, context, entity, intl)}
          <FormattedMessage id={message} />
        </span>
      </Table.Cell>
      <Table.Cell collapsing className={clsx('aridhia-message-cell-content', className)} title={title}>
        {children}
      </Table.Cell>
    </Table.Row>
  );
};

export default MessageRow;
